<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
       
        <a-config-provider>
          <template v-slot:renderEmpty>
            <a-empty>
              <span slot="description">还没有数据~</span>
            </a-empty>
          </template>
          <div class="config-provider">
            <a-button  type="primary"  :style="{ margin: '5px' }"  class="ui-search-action" @click="chooseCertificate()">选择证书</a-button>
            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="list.pagination"
              :dataSource="list.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="type" slot-scope="type">
                <span v-if="type==1">专业课</span>
                <span v-else-if="type==2">公需课</span>
              </span>
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==1" color="green">启用</a-tag>
                <a-tag v-else color="red">禁用</a-tag>
              </span>
              <span slot="trigger" slot-scope="trigger">
          <template v-if="trigger.type==0">学分({{trigger.value}})</template>
          <template v-if="trigger.type==1">学时({{trigger.value}})</template>
          <template v-if="trigger.type==2">关联课程</template>
          <template v-if="trigger.type==3">关联考试</template>
        </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="编辑" size="small" @click="showCertificateInfo(info.id)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="条件设置" size="small" @click="setTrigger(info.id)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="移除" size="small" @click="delInfo(info.id)" type="default" />
              </span>
            </a-table>
<!--            <div class="totalbox" style="float: left;">-->
<!--              <div>-->
<!--                <span>共有：{{list.pagination.total}}条数据</span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </a-config-provider>

      <a-modal
        v-model="chooseCertificateShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <certificateChoose @callbackMethod="addCertificate" :ids="list.ids"/>
      </a-modal>

      <a-modal
        v-model="editCertificateShow"
        :footer="false"
        destroyOnClose
        title="证书信息"
        width="40%"
        :maskClosable="false"
        class="ui-modal"
      >
        <certificateInfo @callbackMethod="addCertificate" :id="list.editId"/>
      </a-modal>
      <a-modal
        v-model="triggerModal.triggerShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <trigger @callbackMethod="closeTrigger" :projectId="projectId" :id="triggerModal.id" :dataType="2"/>
      </a-modal>
    </div>
    
  </a-spin>
</template>

<script>
import certificateChoose from "./certificateChoose.vue";
import certificateInfo from "../certificate/basicInfo.vue";
import trigger from "./trigger.vue";
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "序号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "证书名称"
  },
  {
    dataIndex: "type",
    key: "type",
    align: "center",
    title: "证书类型",
    scopedSlots: { customRender: "type" }
  },
  {
    dataIndex: "trigger",
    key: "trigger",
    align: "center",
    title: "发证条件",
    scopedSlots: { customRender: "trigger" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;

export default {
  name: "trainRecord",
  props: {
    projectId:String
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        ids:[],
        editId:0,
        trigger:{}
      },
      triggerModal:{
        triggerShow: false,
        id:0
      },
      form: this.$form.createForm(this),
     
      isloading: false,
      loadingTip: "加载中...",
      chooseCertificateShow: false, //选择证书
      editCertificateShow: false,//编辑
    };
  },
  components: {
    certificateChoose: certificateChoose,
    certificateInfo: certificateInfo,
    trigger
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  methods: {
    setTrigger(id){
      this.triggerModal.triggerShow=true;
      this.triggerModal.id=id;
    },
    closeTrigger(flag){
      this.triggerModal.triggerShow=false;
      if(flag){
        this.GetList();
      }
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    GetList() {
      if(this.projectId>0){
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .getCertificatesForProject(
            this.projectId
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
                this.list.datas = res.data.certificates;
                this.list.trigger=res.data.trigger;
                this.list.ids=[];
                if(this.list.datas){
                  this.list.datas.forEach(function(item,index){
                    that.list.ids.push(item.id);
                    if(that.list.trigger){
                        for(var t in that.list.trigger){
                          if(that.list.trigger[t].dataId==item.id){
                            item.trigger=that.list.trigger[t];
                          }
                        }
                    }
                    
                  })
                }
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }
    },
    //选择课程
    chooseCertificate() {
      this.chooseCertificateShow = true;
    },
    addCertificate(ids) {
      this.chooseCertificateShow = false;
      this.isloading = true;
        this.clearRows();
        this.$api.project
          .addCertificateToProject(
            this.projectId,ids
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    showCertificateInfo(id) {
      this.editCertificateShow = true;
      this.list.editId=id;
    },
    closeCertificateInfo(id) {
      this.editCertificateShow = false;
      if(id){
        //新增，需要增加关联关系
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .addCertificateToProject(
            this.projectId,id
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }
    },
    delInfo(id){
       this.$confirm({
          title: "提示",
          content: "您确定要移除证书吗",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isloading = true;
            that.clearRows();
            that.$api.project
              .removeCertificateFromProject(
                that.projectId,id
              )
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
          },
          onCancel() {}
        });
        
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    
  }
};
</script>
<style>
</style>